export enum ObservationType {
    ALERT = '1001'
}